import React from 'react';
import { TrendingUp, ExternalLink } from 'lucide-react';
import TradingViewNews from './TradingViewNews';

const MarketNews = () => {
  return (
    <section id="market-news" className="relative bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-24 overflow-hidden">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(16, 185, 129, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(16, 185, 129, 0.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      {/* Glow Effects */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl"></div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full shadow-lg shadow-emerald-500/20 mb-6">
            <TrendingUp className="w-4 h-4 text-emerald-400 animate-pulse" />
            <span className="text-emerald-400 text-sm font-semibold tracking-wide">REAL-TIME UPDATES</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Latest{' '}
            <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
              Market Insights
            </span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto mb-2">
            Stay informed with real-time financial news and market updates from top sources worldwide
          </p>
        </div>

        {/* TradingView News Feed */}
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-slate-900/80 to-slate-950/80 backdrop-blur-xl border border-slate-800/50 rounded-3xl p-6 sm:p-8 shadow-2xl overflow-hidden">
            <TradingViewNews />
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-8">
            <a
              href="https://www.tradingview.com/markets/news/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-emerald-500/10 to-cyan-500/10 hover:from-emerald-500/20 hover:to-cyan-500/20 border border-emerald-500/30 hover:border-emerald-500/50 text-emerald-400 font-semibold rounded-xl transition-all duration-300"
            >
              <span>View All Market News</span>
              <ExternalLink className="w-4 h-4" />
            </a>
            <p className="text-xs text-slate-500 mt-4">
              Powered by <span className="text-emerald-400 font-semibold">TradingView</span>
            </p>
          </div>
        </div>

        {/* Bottom Info */}
        <div className="text-center mt-8">
          <p className="text-slate-500 text-sm">
            Real-time market news updates • Stay ahead of market movements
          </p>
        </div>
      </div>
    </section>
  );
};

export default MarketNews;
